import { useEffect } from 'react';
import styled from 'styled-components';

const OrderBookHistoryWrapper = styled.div`
  border: 1px solid var(--color-gray11);
  width: 134px;
`
const OrderBookWrapper = styled.div`
  font-size: 1.2rem;
`

/**
 * 교재주문 내역
 * @returns 
 */
export const OrderBookHistory = ({ width, items = [], header = 2 }) => {
  // console.log(items)
  useEffect(()=>{
    // console.log(items)
  },[items])

  return (
    <>{items?.length > 0 && (
      <OrderBookHistoryWrapper>
        {items.map((item, index) => {
          const backgroundColor = (index < header) ? 'var(--color-gray10)' : '';
          return <OrderBookWrapper style={{ backgroundColor }}>{item}</OrderBookWrapper>;
        })}
      </OrderBookHistoryWrapper>)}
    </>
  );
};
 